import React, { useState } from 'react';
import styled from 'styled-components';


const Header = styled.h2`
  font-size: 1.5rem;
  font-weight: 500;
  margin-top: 0;
  margin-bottom: 20px;
`;


const Body = styled.div`
  display: flex;
  gap: 30px;
  align-items: center;
`;

const TextContent = styled.div`
  flex: 1;
  font-size: 1rem;
  color: #333;
  line-height: 1.6;

  ul {
    padding-left: 20px;
    margin-top: 15px;
  }
  li {
    margin-bottom: 10px;
  }
`;

const VideoPlaceholder = styled.div`
  flex: 1;
  background-color: #444;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 250px;
`;

const PlayButton = styled.div`
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.1);
  border: 2px solid white;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 2rem;
`;

const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 30px;
`;

const ToggleLabel = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 0.9rem;
  color: #555;
`;

const GetStartedButton = styled.button`
  padding: 10px 30px;
  border-radius: 4px;
  border: none;
  background-color: #F89B3C;
  color: white;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
`;


const IntroPage = ({ onGetStarted, onHideToggle }) => {
    const [isChecked, setIsChecked] = useState(false);

    const handleToggle = (e) => {
        setIsChecked(e.target.checked);
        onHideToggle(e.target.checked);
    };

    return (
        <>
            <Header>Build a Mobile App</Header>
            <Body>
                <TextContent>
                    <p>Effortlessly transition your desktop apps to mobile:</p>
                    <ul>
                        <li>This tool is crafted to enhance your existing apps for a seamless and enjoyable mobile experience.</li>
                        <li>To ensure better results make sure your desktop controls have been properly named and ordered using the "Tab Index" property.</li>
                        <li>Your controls' sizes will be automatically optimized for you.</li>
                        <li>Take a moment to watch our Quick Tour Video, showcasing a quick example to help you make the most of your mobile design.</li>
                    </ul>
                </TextContent>
                <VideoPlaceholder>
                    <PlayButton>▶</PlayButton>
                </VideoPlaceholder>
            </Body>
            <Footer>
                <ToggleLabel>
                    <input type="checkbox" checked={isChecked} onChange={handleToggle} />
                    <span style={{ marginLeft: '8px' }}>Hide at Startup</span>
                </ToggleLabel>
                <GetStartedButton onClick={onGetStarted}>Get Started</GetStartedButton>
            </Footer>
        </>
    );
};

export default IntroPage;